import {
  useAddressAutocomplete as useAddressAutocompleteBase,
  formatAddressLabel,
  type UseAddressAutocompleteOptions
} from '@gjensidige/se-common-calculation';
import { getAutocompleteAddressOptions } from '../api-config';

export const useAddressAutocomplete = (
  searchQuery: string,
  options: UseAddressAutocompleteOptions = {}
) => {
  return useAddressAutocompleteBase(searchQuery, getAutocompleteAddressOptions, options);
};

export { formatAddressLabel };